import {
    fetchTermsConditions,
    fetchHnWAssessmentList,
    saveAssessmentAnswer,
    fetchHnWAssessmentHistoryLog,
} from '../../services/healthWellness/healthWellness.service';

export const stressSex = [{ key: 'male', label: 'เพศชาย' }, { key: 'female', label: 'เพศหญิง' }];
export const stressAge = [{ key: '18', label: '18 หรือต่ำกว่า' }, { key: '19-22', label: '19-22' }, { key: '23-26', label: '23-26' }, { key: '27-30', label: '27-30' }, { key: '31-35', label: '31-35' }, { key: '36-45', label: '36-45' }, { key: '46', label: '46+' }];

const waitCustomer = async (timeout = 15000) => {
    const start = Date.now();

    while (Date.now() - start < timeout) {
        const customer = JSON.parse(
            sessionStorage.getItem('customer') || 'null'
        );

        if (customer) {
            return customer;
        }

        await new Promise(resolve => setTimeout(resolve, 200));
    }

    return null;
};

const mapStressHistory = (logHistory = []) => {
    return logHistory.map(item => ({
        ...item,
        result: item.metaData?.totalScore ?? item.totalScore ?? item.result ?? 0,
        sex: item.metaData?.sex ?? item.sex ?? '',
        age: item.metaData?.age ?? '',
    }));
};

export const loadStressAssessmentData = async () => {
    const assessmentId = new URLSearchParams(window.location.search).get('id');

    if (!assessmentId) { window.location.replace(window.location.origin); return; }

    let assessment = JSON.parse(sessionStorage.getItem('stressAssessment') || 'null');
    let tc = JSON.parse(sessionStorage.getItem('stressTermsConditions') || 'null');

    if (!assessment || !tc) {
        [assessment, tc] = await Promise.all([
            fetchHnWAssessmentList(assessmentId, 'stress'),
            fetchTermsConditions('stressAssessment')
        ]);

        sessionStorage.setItem('stressAssessment', JSON.stringify(assessment));
        sessionStorage.setItem('stressTermsConditions', JSON.stringify(tc));
    }

    await waitCustomer();

    const rawHistory = await fetchHnWAssessmentHistoryLog(assessmentId, null, 'stress');

    const historyData = mapStressHistory(rawHistory || []);

    return {
        assessment,
        tc,
        logHistory: historyData,
        hasHistory: historyData.length > 0
    };
};

export const sortStressQuestions = assessmentData => {
    return assessmentData?.hw_assessments_questions
        ?.slice()
        ?.sort((a, b) => a.display_order - b.display_order) || [];
};

export const buildStressAnswerData = (question, answer) => ({
    question_id: question._id,
    question_label: question.question_label,
    display_order: question.display_order,
    answer_text: answer.text,
    answer_value: answer.value,
});

export const buildStressAssessmentPayload = answerList => {
    return answerList.map(item => {
        const answerValue = Number(
            item?.answer?.[0]?.answer_value ??
            item?.answer_value ??
            0
        );

        return {
            _id: item.question_id || '',
            answer: item.answer || [
                {
                    answer_text: item.answer_text || '',
                    answer_value: answerValue
                }
            ],
            total_score: [answerValue]
        };
    });
};

export const calculateStressTotalScore = stressAssessmentData => {
    return stressAssessmentData.reduce((sum, item) => {
        return sum + Number(item.total_score?.[0] || 0);
    }, 0);
};

export const submitStressAssessmentAnswer = async (
    assessmentId,
    answerList,
    selectedSex,
    selectedAge
) => {
    const stressAssessmentData =
        buildStressAssessmentPayload(answerList);

    const totalScore =
        calculateStressTotalScore(stressAssessmentData);

    const response = await saveAssessmentAnswer(
        assessmentId,
        stressAssessmentData,
        '',
        'DONE',
        {
            assessment_label: 'stressAssessment',
            scoreMetadata: {
                sex: selectedSex,
                age: selectedAge
            }
        }
    );

    await new Promise(resolve => setTimeout(resolve, 300));

    const rawHistory = await fetchHnWAssessmentHistoryLog(
        assessmentId,
        null,
        'stress'
    );

    const historyData = mapStressHistory(rawHistory || []);

    return {
        response,
        totalScore,
        logHistory: historyData
    };
};

export const getStressResult = (score, assessmentData) => {
    const suggestions =
        assessmentData?.metaData?.suggestions || [];

    const matchedIndex = suggestions.findIndex(
        item =>
            score >= item.score_from &&
            score <= item.score_to
    );

    if (matchedIndex === -1) return null;

    const matched = suggestions[matchedIndex];

    const classSuggestions = ['none', 'low', 'medium', 'high', 'veryhigh'];
    const levelSuggestions = ['เครียดระดับต่ำ', 'เครียดระดับเริ่มสะสม', 'เครียดระดับปานกลาง', 'เครียดระดับสูง', 'เครียดระดับรุนแรง'];

    return {
        className: classSuggestions[matchedIndex],
        level: levelSuggestions[matchedIndex],
        range: `ระดับคะแนน ${matched.score_from}-${matched.score_to}`,
        desc: matched.suggestion,
        image: `/images/stress/stresstest_score${matchedIndex + 1}.png`
    };
};

export const preloadImage = src => {
    return new Promise(resolve => {
        if (!src) {
            resolve();
            return;
        }

        const img = new Image();

        img.onload = resolve;
        img.onerror = resolve;
        img.src = src;
    });
};